var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('img',{class:_vm.$style.innate,attrs:{"src":require("@/assets/imgs/innate.png")}}),_c('innate-tooltip',{attrs:{"hero":_vm.hero.name,"position":"bottom"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }